module.exports = __webpack_public_path__ + "img/_tune.6a7aeb3d.svg";